(() => {
  if (!customElements.get("echo-slider")) {
    class echoSlider extends HTMLElement {
      constructor() {
        super();
      }

      init() {
        const slider = this.querySelector(".swiper");
        const pagination = this.querySelector(".swiper-pagination");

        const buttonNext = this.querySelector(".slider-button-next");
        const buttonPrev = this.querySelector(".slider-button-prev");

        const slideAutoPlay = this.getAttribute("data-autoplay");
        const slidesPerView = this.getAttribute("data-slide-per-row");
        const spaceBetween = this.getAttribute("data-space-between");
        const spaceBetweenMb = this.getAttribute("data-space-mb");
        const showDots = this.getAttribute("data-show-dots");
        const showArrows = this.getAttribute("data-show-arrows");
        const loop = this.getAttribute("data-loop") === "true";
        const centerSlide = this.getAttribute("data-centerslide") === "true";

        const mobileSlidesPerView = this.getAttribute(
          "data-mobile-slide-per-row"
        );

        const swiperOptions = {
          slidesPerView: mobileSlidesPerView,
          spaceBetween: spaceBetweenMb,
          centeredSlides: centerSlide,
          slideToClickedSlide: true,
          loop: loop,
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: spaceBetween,
              centeredSlides: centerSlide,
            },
            768: {
              slidesPerView: slidesPerView,
              spaceBetween: spaceBetween,
              centeredSlides: centerSlide,
            },
          },
        };

        // Check if data-autoplay is set to 'true', if so, to enable autoplay
        if (slideAutoPlay === "true") {
          swiperOptions.autoplay = {
            delay: 3000,
            disableOnInteraction: false,
          };
        }

        // Check if data-show-dots is set to 'true', if so, include pagination options
        if (showDots === "true") {
          swiperOptions.pagination = {
            el: pagination,
            clickable: true,
          };
        }

        // Check if data-show-arrows is set to 'true', if so, include arrows options
        if (showArrows === "true") {
          swiperOptions.navigation = {
            nextEl: buttonNext,
            prevEl: buttonPrev,
          };
        }

        const swiper = new Swiper(slider, swiperOptions);
      }

      connectedCallback() {
        this.init();
      }
    }
    customElements.define("echo-slider", echoSlider);
  }
})();